export const getSize = (breakpoint) => {
  let size = 52.5;

  if (breakpoint === 'l' || breakpoint === 'xl') {
    size = 67.5;
  }

  return size;
};
